import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, SkipForwardIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { DialogueList } from '../story/DialogueList';
import { Button } from '../story/Button';
import { SceneIllustration } from '../art/SceneIllustration';
import { PrequelArt } from '../art/PrequelArt';
import { prequelPanels, prequelSkipRecap, purrAnchorUnlockNote } from '../../data/prequel';
export function PrequelStoryScreen() {
  const {
    state,
    dispatch
  } = useDemo();
  const step = Math.min(state.prequelStep, prequelPanels.length - 1);
  const panel = prequelPanels[step];
  const isLast = step === prequelPanels.length - 1;
  const goPrevious = () => {
    if (step === 0) dispatch({
      type: 'BACK'
    });else dispatch({
      type: 'SET_PREQUEL_STEP',
      step: step - 1
    });
  };
  const goNext = () => {
    if (isLast) dispatch({
      type: 'COMPLETE_PREQUEL',
      route: 'story',
      recap: purrAnchorUnlockNote
    });else dispatch({
      type: 'SET_PREQUEL_STEP',
      step: step + 1
    });
  };
  return <ScreenContainer data-id="element-239" data-mp="sn3dww20riv4">
      <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-240" data-mp="smljm4yx3epu">
        <p className="text-sm font-bold text-teal" data-id="element-241" data-mp="ntsgflj3kefv">SixBefore: The Girl Who Heard Too Much</p>
        <p className="text-sm text-ink/80" data-id="element-242" data-mp="iv7gln7rbwry">
          Panel {step + 1} of {prequelPanels.length}
        </p>
      </div>
      <div className="mt-3 grid gap-8 lg:grid-cols-[1.35fr_1fr] lg:items-start" data-id="element-243" data-mp="dy79ra332pzs">
        <SceneIllustration description={panel.description} quietTitle={panel.title} data-id="element-244" data-mp="8x1hfddc54qs">
          <div key={panel.id} className="anim-enter" data-id="element-245" data-mp="4x94ypktmeg5">
            <PrequelArt panel={panel.id} label={panel.description} data-id="element-246" data-mp="4y2bpqjs53ya" />
          </div>
        </SceneIllustration>
        <div data-id="element-247" data-mp="1z9yyh67a1ln0">
          {panel.label && <p className="mb-3 inline-block rounded-full bg-sand px-3 py-1 text-sm font-bold text-forest" data-id="element-248" data-mp="1z8xoz65wt77e">{panel.label}</p>}
          <ScreenHeading focusKey={step} data-id="element-249" data-mp="1u9b90oyp5cuw">{panel.title}</ScreenHeading>
          <DialogueList key={panel.id} lines={panel.lines} className="anim-enter mt-5" data-id="element-250" data-mp="2de7q0l5g5p0e" />
          {isLast && <p className="mt-4 rounded-xl border border-line bg-paper p-4 text-ink hc-strong" data-id="element-251" data-mp="2i7sffosz5anz">
              The phone glow becomes an acacia leaf.
            </p>}
        </div>
      </div>
      <div className="mt-8 flex flex-col-reverse gap-3 border-t border-line pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-252" data-mp="29efcrv53yuop">
        <Button variant="secondary" onClick={goPrevious} icon={<ArrowLeftIcon size={18} aria-hidden="true" data-id="element-254" data-mp="314tmrga03mv3" />} data-id="element-253" data-mp="315d713n4inca">
          Previous
        </Button>
        <div className="flex flex-col gap-3 sm:flex-row" data-id="element-255" data-mp="2n4snu6daqpi9">
          {!isLast && <Button variant="quiet" onClick={() => dispatch({
          type: 'COMPLETE_PREQUEL',
          route: 'skip',
          recap: `${prequelSkipRecap} ${purrAnchorUnlockNote}`
        })} icon={<SkipForwardIcon size={18} aria-hidden="true" data-id="element-257" data-mp="1gqtb4sffy04h" />} data-id="element-256" data-mp="2s3m1bysl2gif">
              Skip story
            </Button>}
          <Button onClick={goNext} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-259" data-mp="145unzbsbv9nn" />} data-id="element-258" data-mp="146waqdiphkl7">
            {isLast ? 'Enter the Bridge' : 'Next'}
          </Button>
        </div>
      </div>
    </ScreenContainer>;
}